import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AbaConciliacao, AbaRecorrencias, AbaDre, AbaFluxo, AbaContas, AbaAuditoria } from './FinanceiroAbas';

const BASE = '/';
const token = () => localStorage.getItem('token');
const apiGet = (p) => fetch(`${BASE}${p}${p.includes('?') ? '&' : '?'}_=${Date.now()}`, {
  headers: { Authorization: `Bearer ${token()}`, 'Cache-Control': 'no-cache' },
}).then(r => r.json());
const apiSend = (p, m, b) => fetch(`${BASE}${p}`, {
  method: m, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
  body: b ? JSON.stringify(b) : undefined,
}).then(r => r.json());

const moeda = (v) => (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
// Máscara de moeda que formata enquanto digita: "123456" → "1.234,56"
const mascaraMoeda = (v) => {
  const n = String(v).replace(/\D/g, '');
  if (!n) return '';
  const val = (parseInt(n, 10) / 100).toFixed(2);
  const [int, dec] = val.split('.');
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
};
const fmtData = (iso) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); return m ? `${m[3]}/${m[2]}/${m[1]}` : '—'; };
const hojeISO = () => new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);
// Semana (domingo a sábado) da data
const inicioSemana = (iso) => { const d = new Date(iso + 'T12:00:00'); const dow = d.getDay(); d.setDate(d.getDate() - dow); return d.toISOString().slice(0, 10); };
const addDias = (iso, n) => { const d = new Date(iso + 'T12:00:00'); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
const ddmm = (iso) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); return m ? `${m[3]}/${m[2]}` : ''; };

const card = { background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, padding: 10 };
const inp = { padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 12, color: '#111', background: '#fff', height: 26, outline: 'none' };
const th = { padding: '5px 10px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em', background: '#0a1628', whiteSpace: 'nowrap' };
const td = { padding: '4px 10px', fontSize: 13, color: '#374151', borderBottom: '1px solid #e8eaed' };

// ── 💰 Central Financeira: casca de abas (12/08/2026) ───────────────────────
// A tela original (contas a pagar/receber) virou a aba Lançamentos; as novas
// abas moram em FinanceiroAbas.js. Nada da tela antiga mudou de comportamento.
export default function Financeiro() {
  const [aba, setAba] = useState('lancamentos');
  const [categorias, setCategorias] = useState([]);
  useEffect(() => {
    apiGet(`financeiro?ano=${new Date().getFullYear()}&mes=0`)
      .then(d => setCategorias((d?.categorias?.pagar || []).map(c => c.nome || c)))
      .catch(() => {});
  }, []);
  const ABAS = [
    ['lancamentos', '📒 Lançamentos'],
    ['conciliacao', '🏦 Conciliação'],
    ['recorrencias', '🔁 Recorrências'],
    ['dre', '📊 DRE'],
    ['fluxo', '💸 Fluxo de Caixa'],
    ['contas', '🏛️ Contas'],
    // Trilha de auditoria: só o admin (o backend barra os demais com 403).
    // Mesmo critério do resto do app: nome OU cargo contendo "admin"
    ...(localStorage.getItem('nomeUsuario') === 'Vagner Freitas' || (localStorage.getItem('cargoUsuario') || '').toLowerCase().includes('admin')
      ? [['auditoria', '🕵️ Auditoria']] : []),
  ];
  return (
    <div style={{ maxWidth: 1180 }}>
      <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
        {ABAS.map(([k, rotulo]) => (
          <button key={k} onClick={() => setAba(k)}
            style={{ padding: '6px 14px', borderRadius: 6, fontSize: 13, fontWeight: aba === k ? 800 : 500, border: '1px solid', borderColor: aba === k ? '#0a1628' : '#d1d5db', background: aba === k ? '#0a1628' : '#fff', color: aba === k ? '#fff' : '#374151', cursor: 'pointer' }}>
            {rotulo}
          </button>
        ))}
      </div>
      {aba === 'lancamentos' && <AbaLancamentos />}
      {aba === 'conciliacao' && <AbaConciliacao categorias={categorias} />}
      {aba === 'recorrencias' && <AbaRecorrencias categorias={categorias} />}
      {aba === 'dre' && <AbaDre />}
      {aba === 'fluxo' && <AbaFluxo />}
      {aba === 'contas' && <AbaContas />}
      {aba === 'auditoria' && <AbaAuditoria />}
    </div>
  );
}

function AbaLancamentos() {
  const navigate = useNavigate();
  const location = useLocation();
  // Voltando da ficha (clique no nome), o filtro guardado no histórico volta
  // junto; aberto pelo menu, o Financeiro começa no mês atual como sempre
  const voltou = location.state?.filtrosFinanceiro;
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [f, setF] = useState(voltou?.f || { tipo: 'tudo', cliente: '', ano: String(new Date().getFullYear()), mes: String(new Date().getMonth() + 1), data_base: 'vencimento' });
  // Filtro por status, aplicado na tela: '' = tudo, 'aberto' ou 'quitado'
  const [statusF, setStatusF] = useState(voltou?.statusF || '');

  // ── Clique no nome → cadastro (pedido 28/10/2026) ──────────────────────
  // Antes de sair, guarda o filtro na entrada atual do histórico: o "voltar"
  // do navegador reabre o Financeiro no mesmo mês, tipo e status.
  function irPara(rota) {
    navigate(location.pathname + location.search, { replace: true, state: { ...(location.state || {}), filtrosFinanceiro: { f, statusF } } });
    navigate(rota);
  }
  const [procurando, setProcurando] = useState('');
  async function abrirCadastro(e, it) {
    // Cmd/Ctrl/Shift ou botão do meio: deixa o navegador abrir em outra aba
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    if (it.cliente_id) return irPara(`/clientes/${it.cliente_id}/editar`);
    if (it.fornecedor_id) return irPara(`/fornecedores/${it.fornecedor_id}/editar`);
    // Avulso só com o nome digitado, sem vínculo: procura o cadastro pelo nome
    // (mesma busca do topo) e abre se achar um só
    const nome = (it.cliente_nome || '').trim();
    if (!nome || procurando) return;
    setProcurando(it.id);
    let achados = null;
    try { achados = await apiGet(`clientes?busca=${encodeURIComponent(nome)}`); } catch { /* cai no aviso */ }
    setProcurando('');
    if (!Array.isArray(achados)) return window.alert('Não deu para procurar o cadastro agora. Tente de novo.');
    if (achados.length === 1) return irPara(`/clientes/${achados[0]._id}/editar`);
    window.alert(achados.length
      ? `Achei ${achados.length} cadastros com "${nome}": ${achados.slice(0, 5).map(c => c.nome || c.razao_social || c.nome_marca).join(', ')}${achados.length > 5 ? '…' : ''}.\n\nUse o ✏️ do lançamento para ligar ao cliente certo.`
      : `Este lançamento não está ligado a nenhum cadastro e não achei cliente com o nome "${nome}".\n\nPara ligar, use o ✏️ do lançamento e escolha o cliente.`);
  }
  const [modal, setModal] = useState(false);
  const [lote, setLote] = useState(false); // modal de baixa em lote
  const [baixa, setBaixa] = useState(null);
  const [coment, setComent] = useState(null);
  const [baixando, setBaixando] = useState('');
  // Edição do valor direto na linha (clica no valor → input → Enter/sair salva)
  const [editValor, setEditValor] = useState(null); // id do lançamento
  const [valorTmp, setValorTmp] = useState('');
  const cancelEdicao = useRef(false);

  async function salvarValorInline(it) {
    setEditValor(null);
    const bruto = valorTmp.trim();
    if (!bruto) return;
    const novo = parseFloat(bruto.replace(/[R$\s]/g, '').replace(/\./g, '').replace(',', '.'));
    if (isNaN(novo) || novo < 0 || novo === it.valor) return;
    const r = await apiSend(`financeiro/${it.id}`, 'PUT', { valor: novo }).catch(() => ({ erro: 'Falha ao salvar' }));
    if (r?.erro) return window.alert(r.erro);
    carregar(); // atualiza a linha, os totais do grupo e os cards
  }

  const carregar = useCallback(async () => {
    const qs = Object.entries(f).filter(([, v]) => v).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');
    try { setDados(await apiGet(`financeiro?${qs}`)); } catch { /* silencioso */ }
    setCarregando(false);
  }, [f]);

  useEffect(() => { carregar(); }, [carregar]);

  const marcar = async (it) => {
    await apiSend(`financeiro/${it.id}/status`, 'PUT', { status: it.status === 'quitado' ? 'aberto' : 'quitado' });
    carregar();
  };
  const excluir = async (it) => {
    if (!window.confirm('Excluir este lançamento?')) return;
    await apiSend(`financeiro/${it.id}`, 'DELETE');
    carregar();
  };
  const exportar = async (fmt) => {
    setBaixando(fmt);
    try {
      const qs = Object.entries(f).filter(([, v]) => v).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');
      const resp = await fetch(`${BASE}financeiro/export/${fmt}?${qs}`, { headers: { Authorization: `Bearer ${token()}` } });
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = fmt === 'excel' ? 'financeiro.xlsx' : 'financeiro.pdf';
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch { alert('Erro ao gerar arquivo.'); }
    setBaixando('');
  };

  const r = dados?.resumo || {};
  const itens = (dados?.itens || []).filter(it => !statusF || it.status === statusF);

  const Metric = ({ label, valor, cor, sub }) => (
    <div style={{ background: '#f5f7fa', border: '1px solid #e2e8f0', borderRadius: 4, padding: '6px 10px', flex: 1, minWidth: 130 }}>
      <div style={{ fontSize: 11, color: '#6b7280' }}>{label}</div>
      <div style={{ fontSize: 16, fontWeight: 700, color: cor || '#0a1628' }}>{moeda(valor)}</div>
      {sub && <div style={{ fontSize: 10, color: '#9ca3af' }}>{sub}</div>}
    </div>
  );

  return (
    <div style={{ padding: 4 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
        <h1 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>💵 Financeiro</h1>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button onClick={() => exportar('pdf')} disabled={!!baixando} style={{ ...inp, cursor: 'pointer', height: 28 }}>{baixando === 'pdf' ? '...' : '📄 PDF'}</button>
          <button onClick={() => exportar('excel')} disabled={!!baixando} style={{ ...inp, cursor: 'pointer', height: 28 }}>{baixando === 'excel' ? '...' : '📊 Excel'}</button>
          <button onClick={() => setModal({ tipo: 'receber' })} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>+ A receber</button>
          <button onClick={() => setModal({ tipo: 'pagar' })} style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>+ A pagar</button>
          <button onClick={() => setLote(true)} title="Dar baixa em várias parcelas de uma vez"
            style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>💰 Baixa em lote</button>
          <button onClick={() => navigate('/fornecedores')} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>🏭 Fornecedores</button>
          <button onClick={() => navigate('/capital')} style={{ background: '#b45309', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>💰 Capital</button>
          <div style={{ display: 'flex', gap: 4, marginLeft: 4 }}>
            {[
              { k: 'tudo', label: 'Todos' },
              { k: 'pagar', label: 'Contas a Pagar' },
              { k: 'receber', label: 'Contas a Receber' },
            ].map(t => (
              <button key={t.k} onClick={() => setF({ ...f, tipo: t.k })} style={{
                borderRadius: 4, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                border: '1px solid ' + (f.tipo === t.k ? '#0a1628' : '#c8d0da'),
                background: f.tipo === t.k ? '#0a1628' : '#fff', color: f.tipo === t.k ? '#fff' : '#374151',
              }}>{t.label}</button>
            ))}
          </div>
        </div>
      </div>

      {/* Cards */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
        <Metric label="A receber (aberto)" valor={r.a_receber} cor="#16a34a" />
        <Metric label="A receber (total)" valor={(r.a_receber || 0) + (r.recebido || 0)} cor="#15803d" sub={`${moeda(r.recebido)} já recebido`} />
        <Metric label="A pagar (aberto)" valor={r.a_pagar} cor="#dc2626" />
        <Metric label="A pagar (total)" valor={(r.a_pagar || 0) + (r.pago || 0)} cor="#991b1b" sub={`${moeda(r.pago)} já pago`} />
        <Metric label="Saldo previsto" valor={r.saldo_previsto} cor={(r.saldo_previsto || 0) >= 0 ? '#16a34a' : '#dc2626'} />
        {(() => {
          // Saldo total = receber (total) − pagar (total), contando o já movimentado
          const saldoTotal = ((r.a_receber || 0) + (r.recebido || 0)) - ((r.a_pagar || 0) + (r.pago || 0));
          return <Metric label="Saldo total" valor={saldoTotal} cor={saldoTotal >= 0 ? '#16a34a' : '#dc2626'} sub="receber total − pagar total" />;
        })()}
        <Metric label="Vencidos" valor={r.vencidos} cor="#b45309" />
      </div>

      {/* Filtros — apenas ano + meses (estilo autoatendimento) */}
      <div style={{ ...card, display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 8 }}>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          <input value={f.cliente} onChange={e => setF({ ...f, cliente: e.target.value })} placeholder="🔎 Buscar por cliente, fornecedor ou descrição..." style={{ ...inp, flex: 1 }} />
          {f.cliente && <button onClick={() => setF({ ...f, cliente: '' })} style={{ ...inp, cursor: 'pointer', color: '#6b7280' }}>limpar</button>}
          <div style={{ display: 'flex', gap: 4 }}>
            {[
              { k: '', label: 'Tudo' },
              { k: 'aberto', label: '⏳ Em aberto', ativoBg: '#b45309' },
              { k: 'quitado', label: '✓ Pagos', ativoBg: '#15803d' },
            ].map(t => {
              const ativo = statusF === t.k;
              return (
                <button key={t.k} onClick={() => setStatusF(t.k)} style={{
                  borderRadius: 4, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
                  border: '1px solid ' + (ativo ? (t.ativoBg || '#0a1628') : '#c8d0da'),
                  background: ativo ? (t.ativoBg || '#0a1628') : '#fff', color: ativo ? '#fff' : '#374151',
                }}>{t.label}</button>
              );
            })}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>Ano:</span>
          <select value={f.ano} onChange={e => setF({ ...f, ano: e.target.value })} style={{ ...inp, minWidth: 100, fontWeight: 600 }} title="Ano">
            {Array.from({ length: 2040 - 2022 + 1 }, (_, k) => 2022 + k).map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
          {['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'].map((nome, k) => {
            const m = String(k + 1);
            const ativo = f.mes === m;
            return (
              <button key={k} onClick={() => setF({ ...f, mes: ativo ? '' : m })} style={{
                flex: 1, padding: '4px 0', fontSize: 12, fontWeight: 700, borderRadius: 6, cursor: 'pointer',
                border: '1px solid ' + (ativo ? '#0a1628' : '#c8d0da'),
                background: ativo ? '#0a1628' : '#fff', color: ativo ? '#fff' : '#374151',
              }}>{nome}</button>
            );
          })}
        </div>
        {f.mes && <div style={{ textAlign: 'center' }}><button onClick={() => setF({ ...f, mes: '' })} style={{ ...inp, cursor: 'pointer', color: '#6b7280' }}>ver o ano todo</button></div>}
      </div>

      {/* Tabela */}
      {carregando ? (
        <div style={{ ...card, textAlign: 'center', color: '#6b7280', padding: 24 }}>Carregando...</div>
      ) : (itens.length === 0) ? (
        <div style={{ ...card, textAlign: 'center', color: '#6b7280', padding: 24 }}>Nenhum lançamento para os filtros atuais.</div>
      ) : (
        <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflow: 'hidden' }}>
          <div style={{ maxHeight: 600, overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
              <thead>
                <tr>
                  <th style={{ ...th, position: 'sticky', top: 0, width: 26, padding: 0 }}></th>
                  {['Tipo', 'Descrição', 'Cliente / Fornecedor', 'Categoria', 'Vencimento', 'Valor', 'Status', 'Ações'].map((h, i) => (
                    <th key={i} style={{ ...th, textAlign: i === 5 ? 'right' : 'left', position: 'sticky', top: 0 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(() => {
                  // Agrupa por semana (consecutivos, já ordenados por vencimento)
                  const grupos = [];
                  itens.forEach(it => {
                    const key = it.vencimento ? inicioSemana(it.vencimento) : 'sem';
                    const ult = grupos[grupos.length - 1];
                    if (!ult || ult.key !== key) grupos.push({ key, items: [it] });
                    else ult.items.push(it);
                  });
                  const cores = [
                    { borda: '#84cc16', tint: '#ecfccb', label: '#a3e635', txt: '#365314' }, // verde limão neon
                    { borda: '#fb7a1a', tint: '#ffedd5', label: '#fb923c', txt: '#7c2d12' }, // laranja cítrico neon
                  ];
                  const linhas = [];
                  let zebra = 0;
                  // Linha "hoje": marca o 1º lançamento futuro (vencimento > hoje). Só no mês corrente.
                  const hoje = hojeISO();
                  const mostrarHoje = String(f.ano) === hoje.slice(0, 4) && Number(f.mes) === Number(hoje.slice(5, 7));
                  let idxHoje = -1;
                  if (mostrarHoje && itens.length) {
                    idxHoje = itens.findIndex(it => it.vencimento && it.vencimento > hoje);
                    if (idxHoje === -1) idxHoje = itens.length; // tudo já venceu → linha no fim
                  }
                  let gIdx = 0;
                  grupos.forEach((g, gi) => {
                    const cor = cores[gi % 2];
                    const n = g.items.length;
                    const tPagar = g.items.filter(x => x.tipo === 'pagar').reduce((s, x) => s + x.valor, 0);
                    const tReceber = g.items.filter(x => x.tipo === 'receber').reduce((s, x) => s + x.valor, 0);
                    const periodo = g.key === 'sem' ? 'Sem vencimento' : `${ddmm(g.key)} a ${ddmm(addDias(g.key, 6))}`;
                    linhas.push(
                      <tr key={'wh' + gi}>
                        <td rowSpan={n + 1} style={{ background: cor.label, color: cor.txt, writingMode: 'vertical-rl', textAlign: 'center', verticalAlign: 'middle', fontWeight: 800, fontSize: 10, letterSpacing: 1.5, whiteSpace: 'nowrap', padding: '4px 3px' }}>SEMANA {gi + 1}</td>
                        <td colSpan={8} style={{ background: cor.tint, borderTop: `2px solid ${cor.borda}`, borderRight: `2px solid ${cor.borda}`, padding: '4px 10px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                            <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>📅 {periodo} <span style={{ color: '#6b7280', fontWeight: 400 }}>· {n} lançamento{n !== 1 ? 's' : ''}</span></span>
                            <span style={{ fontSize: 12, fontWeight: 600 }}>{tReceber > 0 && <span style={{ color: '#15803d', marginRight: 12 }}>A receber {moeda(tReceber)}</span>}{tPagar > 0 && <span style={{ color: '#b91c1c' }}>A pagar {moeda(tPagar)}</span>}</span>
                          </div>
                        </td>
                      </tr>
                    );
                    g.items.forEach((it, idx) => {
                      const ultima = idx === n - 1;
                      const meuIdx = gIdx++;
                      const ehLinhaHoje = mostrarHoje && meuIdx === idxHoje;
                      const ehLinhaHojeFim = mostrarHoje && idxHoje === itens.length && meuIdx === itens.length - 1;
                      const vencido = it.status === 'aberto' && it.vencimento && it.vencimento < hojeISO();
                      const rec = it.tipo === 'receber';
                      const bg = it.status === 'quitado' ? '#f3f6f4' : (zebra++ % 2 === 0 ? '#fff' : '#fafafa');
                      const lt = ehLinhaHoje ? { borderTop: '3px solid #111' } : {};
                      const lb = ehLinhaHojeFim ? { borderBottom: '3px solid #111' } : {};
                      const cb = { ...(ultima ? { borderBottom: `2px solid ${cor.borda}` } : {}), ...lt, ...lb };
                      const cbR = { ...cb, borderRight: `2px solid ${cor.borda}` };
                      linhas.push(
                        <tr key={it.id} style={{ background: bg }}
                          onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                          onMouseLeave={e => e.currentTarget.style.background = bg}>
                          <td style={{ ...td, ...cb, whiteSpace: 'nowrap', position: (ehLinhaHoje || ehLinhaHojeFim) ? 'relative' : undefined }}>
                            {(ehLinhaHoje || ehLinhaHojeFim) && <span style={{ position: 'absolute', left: 4, [ehLinhaHojeFim ? 'bottom' : 'top']: -9, background: '#111', color: '#fff', fontSize: 9, fontWeight: 800, padding: '1px 7px', borderRadius: 8, whiteSpace: 'nowrap', zIndex: 3, letterSpacing: 0.5 }}>HOJE {ddmm(hoje)}</span>}
                            <span style={{ fontSize: 11, fontWeight: 700, color: rec ? '#15803d' : '#b91c1c' }}>{rec ? '+ Receber' : '− Pagar'}</span>
                          </td>
                          <td style={{ ...td, ...cb, color: '#111', position: 'relative' }}>
                            {it.comentario && <span title={it.comentario} onClick={() => setComent(it)} style={{ position: 'absolute', top: 0, right: 0, width: 0, height: 0, borderTop: '8px solid #dc2626', borderLeft: '8px solid transparent', cursor: 'pointer' }} />}
                            {it.descricao}
                            {it.origem === 'venda' && <span style={{ fontSize: 10, background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 3, padding: '0 4px', marginLeft: 5 }}>da venda</span>}
                          </td>
                          <td style={{ ...td, ...cb, color: '#6b7280' }}>
                            {(it.cliente_nome || it.fornecedor_nome) ? (() => {
                              const rota = it.cliente_id ? `/clientes/${it.cliente_id}/editar` : (it.fornecedor_id ? `/fornecedores/${it.fornecedor_id}/editar` : '');
                              return (
                                <>
                                  {/* link de verdade quando há vínculo: Cmd/Ctrl+clique abre em outra aba */}
                                  <a href={rota || undefined} role="link" tabIndex={0}
                                    onClick={e => abrirCadastro(e, it)}
                                    onKeyDown={e => { if (e.key === 'Enter' && !rota) abrirCadastro(e, it); }}
                                    title={it.cliente_id ? 'Abrir o cadastro do cliente' : it.fornecedor_id ? 'Abrir o cadastro do fornecedor' : 'Lançamento sem vínculo com o cadastro: clique para procurar o cliente pelo nome'}
                                    style={{ color: '#1d4ed8', cursor: 'pointer', textDecoration: 'none', borderBottom: `1px ${rota ? 'solid' : 'dashed'} #bfdbfe` }}>
                                    {procurando === it.id ? 'Procurando…' : (it.cliente_nome || it.fornecedor_nome)}
                                  </a>
                                  {!it.cliente_nome && <span style={{ fontSize: 10, color: '#9ca3af' }}> (forn.)</span>}
                                </>
                              );
                            })() : '—'}
                          </td>
                          <td style={{ ...td, ...cb, color: '#6b7280' }}>{it.categoria || '—'}{it.subcategoria ? <span style={{ color: '#9ca3af' }}> › {it.subcategoria}</span> : ''}</td>
                          <td style={{ ...td, ...cb, color: vencido ? '#b91c1c' : '#374151', fontWeight: vencido ? 700 : 400, whiteSpace: 'nowrap' }}>{fmtData(it.vencimento)}{vencido && ' ⚠️'}</td>
                          <td style={{ ...td, ...cb, textAlign: 'right', fontWeight: 600, color: rec ? '#15803d' : '#b91c1c', whiteSpace: 'nowrap' }}>
                            {editValor === it.id ? (
                              <input autoFocus value={valorTmp}
                                onChange={e => setValorTmp(e.target.value)}
                                onFocus={e => e.target.select()}
                                onKeyDown={e => {
                                  if (e.key === 'Enter') e.currentTarget.blur();
                                  if (e.key === 'Escape') { cancelEdicao.current = true; e.currentTarget.blur(); }
                                }}
                                onBlur={() => {
                                  if (cancelEdicao.current) { cancelEdicao.current = false; setEditValor(null); return; }
                                  salvarValorInline(it);
                                }}
                                style={{ width: 86, padding: '1px 4px', fontSize: 12, textAlign: 'right', border: '1.5px solid #0a1628', borderRadius: 3, fontWeight: 600 }} />
                            ) : (
                              <span onClick={() => { setEditValor(it.id); setValorTmp(it.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); }}
                                title="Clique pra alterar o valor (Enter salva, Esc cancela)"
                                style={{ cursor: 'pointer', borderBottom: '1px dashed #c8d0da' }}>
                                {moeda(it.valor)}
                              </span>
                            )}
                          </td>
                          <td style={{ ...td, ...cb }}>
                            <button onClick={() => marcar(it)} title="Alternar status" style={{
                              fontSize: 10, fontWeight: 600, borderRadius: 3, padding: '2px 6px', cursor: 'pointer', border: '1px solid', whiteSpace: 'nowrap',
                              ...(it.status === 'quitado'
                                ? { background: '#f0fdf4', color: '#15803d', borderColor: '#bbf7d0' }
                                : { background: '#fff', color: '#b45309', borderColor: '#fde68a' }),
                            }}>{it.status === 'quitado' ? (rec ? '✓ Recebido' : '✓ Pago') : 'Em aberto'}</button>
                          </td>
                          <td style={{ ...td, ...cbR, whiteSpace: 'nowrap' }}>
                            {it.origem === 'avulso' ? (
                              <>
                                <button
                                  onClick={() => it.fornecedor_id ? navigate(`/fornecedores/${it.fornecedor_id}/editar?aba=financeiro`) : setModal({ ...it, editar: true })}
                                  title={it.fornecedor_id ? 'Abrir no cadastro do fornecedor' : 'Editar'} style={btnMini}>✏️</button>
                                <button onClick={() => setBaixa(it)} title={it.status === 'quitado' ? 'Ver baixa do pagamento' : 'Dar baixa / pagar'} style={btnMini}>{it.status === 'quitado' ? '🧾' : '💰'}</button>
                                <button onClick={() => setComent(it)} title={it.comentario || 'Adicionar comentário'} style={{ ...btnMini, ...(it.comentario ? { background: '#fef3c7', borderRadius: 3 } : {}) }}>💬</button>
                                <button onClick={() => excluir(it)} title="Excluir" style={btnMini}>🗑️</button>
                              </>
                            ) : <span style={{ fontSize: 10, color: '#9ca3af' }}>—</span>}
                          </td>
                        </tr>
                      );
                    });
                  });
                  return linhas;
                })()}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {lote && <ModalBaixaLote itens={itens} formas={dados?.formas} onFechar={() => setLote(false)} onSalvo={() => { setLote(false); carregar(); }} />}
      {modal && <ModalConta inicial={modal} categorias={dados?.categorias} formas={dados?.formas} onFechar={() => setModal(false)} onSalvo={() => { setModal(false); carregar(); }} />}
      {baixa && <ModalBaixa item={baixa} formas={dados?.formas} onFechar={() => setBaixa(null)} onSalvo={() => { setBaixa(null); carregar(); }} />}
      {coment && <ModalComentario item={coment} onFechar={() => setComent(null)} onSalvo={() => { setComent(null); carregar(); }} />}
    </div>
  );
}

const btnMini = { background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, padding: '2px 4px' };

function ModalComentario({ item, onFechar, onSalvo }) {
  const [texto, setTexto] = useState(item.comentario || '');
  const [salvando, setSalvando] = useState(false);
  const gravar = async (valor) => {
    setSalvando(true);
    await apiSend(`financeiro/${item.id}/comentario`, 'PUT', { comentario: valor });
    setSalvando(false);
    onSalvo();
  };
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fffbea', border: '1px solid #f0d98a', borderRadius: 8, padding: 16, width: 360, maxWidth: '92%', boxShadow: '0 12px 40px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>📝 Comentário</div>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ fontSize: 11, color: '#92400e', marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.descricao} · {moeda(item.valor)}</div>
        <textarea value={texto} onChange={e => setTexto(e.target.value)} autoFocus placeholder="Escreva uma nota sobre este lançamento…"
          style={{ width: '100%', minHeight: 90, boxSizing: 'border-box', border: '1px solid #e5d9a8', borderRadius: 6, padding: 8, fontSize: 13, fontFamily: 'inherit', resize: 'vertical', background: '#fffdf5', outline: 'none' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
          {item.comentario ? <button onClick={() => gravar('')} disabled={salvando} style={{ background: 'none', border: 'none', color: '#b91c1c', fontSize: 12, cursor: 'pointer' }}>Excluir comentário</button> : <span />}
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={onFechar} style={{ background: '#fff', border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 14px', fontSize: 12, cursor: 'pointer', color: '#374151' }}>Cancelar</button>
            <button onClick={() => gravar(texto)} disabled={salvando} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontSize: 12, fontWeight: 600, cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>{salvando ? 'Salvando…' : 'Salvar'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ModalBaixa({ item, formas, onFechar, onSalvo }) {
  const rec = item.tipo === 'receber';
  const jaQuitado = item.status === 'quitado';
  const total = item.valor_original != null ? item.valor_original : item.valor;
  const [valorPago, setValorPago] = useState((jaQuitado ? item.valor : total).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  const [forma, setForma] = useState(item.pago_forma || item.forma_pagamento || '');
  const [data, setData] = useState(item.data_pagamento ? item.data_pagamento.slice(0, 10) : hojeISO());
  const [gerar, setGerar] = useState(true);
  const [taxa, setTaxa] = useState(''); // taxa de maquineta/banco — vira despesa quitada automática
  const [salvando, setSalvando] = useState(false);

  const numPago = parseFloat(String(valorPago).replace(/\./g, '').replace(',', '.')) || 0;
  const saldo = Math.round((total - numPago) * 100) / 100;

  const confirmar = async () => {
    if (numPago <= 0) return alert('Informe o valor pago.');
    setSalvando(true);
    const r = await apiSend(`financeiro/${item.id}/baixa`, 'PUT', { valor_pago: valorPago, forma, data_pagamento: data, gerar_remanescente: saldo > 0 && gerar, taxa });
    setSalvando(false);
    if (r?.erro) return alert(r.erro);
    onSalvo();
  };
  const estornar = async () => {
    if (!window.confirm('Estornar este pagamento? A conta volta para "em aberto".')) return;
    setSalvando(true);
    await apiSend(`financeiro/${item.id}/status`, 'PUT', { status: 'aberto' });
    setSalvando(false);
    onSalvo();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, padding: 24, width: 420, maxWidth: '92%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        <h2 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: '0 0 4px' }}>{jaQuitado ? '🧾 Baixa do pagamento' : (rec ? '💰 Registrar recebimento' : '💰 Registrar pagamento')}</h2>
        <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 16px' }}>{item.descricao} · total {moeda(total)}</p>

        {jaQuitado ? (
          <div>
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: 14 }}>
              <Linha rotulo={rec ? 'Recebido em' : 'Pago em'} valor={fmtData(item.data_pagamento)} />
              <Linha rotulo="Valor" valor={moeda(item.valor)} destaque />
              {item.valor_original != null && item.valor_original !== item.valor && (
                <Linha rotulo="Valor original" valor={`${moeda(item.valor_original)} (saldo de ${moeda(item.valor_original - item.valor)} gerado)`} />
              )}
              <Linha rotulo="Forma" valor={item.pago_forma || '—'} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', marginTop: 18 }}>
              <button onClick={estornar} disabled={salvando} style={{ ...inp, cursor: 'pointer', color: '#b45309', borderColor: '#fde68a' }}>↺ Estornar</button>
              <button onClick={onFechar} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 20px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Fechar</button>
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>Valor {rec ? 'recebido' : 'pago'}</label>
              <input value={valorPago} onChange={e => setValorPago(mascaraMoeda(e.target.value))} inputMode="numeric" style={{ ...inp, width: '100%', boxSizing: 'border-box' }} />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <div style={{ flex: 1 }}><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>Forma</label>
                <select value={forma} onChange={e => setForma(e.target.value)} style={{ ...inp, width: '100%' }}><option value="">—</option>{(formas || []).map(x => <option key={x} value={x}>{x}</option>)}</select>
              </div>
              <div style={{ flex: 1 }}><label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>Data</label>
                <input type="date" value={data} onChange={e => setData(e.target.value)} style={{ ...inp, width: '100%' }} />
              </div>
            </div>
            {rec && (
              <div>
                <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 3 }}>Taxa de maquineta/banco (R$) — opcional</label>
                <input value={taxa} onChange={e => setTaxa(mascaraMoeda(e.target.value))} inputMode="numeric" placeholder="0,00"
                  title="Se preencher, o sistema cria sozinho a despesa 'Taxa de maquineta' quitada na mesma data" style={{ ...inp, width: '100%', boxSizing: 'border-box' }} />
              </div>
            )}
            {saldo > 0 && (
              <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '10px 12px' }}>
                <div style={{ fontSize: 13, color: '#b45309', fontWeight: 600 }}>Pagamento a menor · saldo de {moeda(saldo)}</div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#374151', marginTop: 4, cursor: 'pointer' }}>
                  <input type="checkbox" checked={gerar} onChange={e => setGerar(e.target.checked)} />
                  Gerar uma nova conta a {rec ? 'receber' : 'pagar'} com o saldo remanescente
                </label>
              </div>
            )}
            {saldo < 0 && <div style={{ fontSize: 12, color: '#b45309' }}>Atenção: valor informado maior que o total.</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 6 }}>
              <button onClick={onFechar} style={{ ...inp, cursor: 'pointer', color: '#374151' }}>Cancelar</button>
              <button onClick={confirmar} disabled={salvando} style={{ background: rec ? '#16a34a' : '#dc2626', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 20px', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>{salvando ? '...' : 'Confirmar baixa'}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
function Linha({ rotulo, valor, destaque }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '2px 0' }}>
      <span style={{ color: '#6b7280' }}>{rotulo}</span>
      <span style={{ fontWeight: destaque ? 700 : 500, color: '#0a1628' }}>{valor}</span>
    </div>
  );
}

function ModalConta({ inicial, categorias, formas, onFechar, onSalvo }) {
  const editar = inicial.editar;
  const [tipo, setTipo] = useState(inicial.tipo || 'receber');
  const [form, setForm] = useState({
    descricao: inicial.descricao || '', valor: inicial.valor ? String(inicial.valor).replace('.', ',') : '',
    vencimento: inicial.vencimento || '', categoria: inicial.categoria || '', subcategoria: inicial.subcategoria || '', forma_pagamento: inicial.forma_pagamento || '',
    cliente_id: inicial.cliente_id || '', cliente_nome: inicial.cliente_nome || '',
    fornecedor_id: inicial.fornecedor_id || '', fornecedor_nome: inicial.fornecedor_nome || '',
  });
  const [numParcelas, setNumParcelas] = useState(1);
  const [quantidade, setQuantidade] = useState(1); // qtd de itens da venda (ex.: 2 registros de marca)
  const [repetir, setRepetir] = useState('');
  const [numRepeticoes, setNumRepeticoes] = useState(4);
  const [salvando, setSalvando] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const diaSemana = (iso) => iso ? ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'][new Date(iso + 'T12:00:00').getDay()] : '';
  const valorNum = parseFloat(String(form.valor).replace(/\./g, '').replace(',', '.')) || 0;
  const freqTxt = repetir === 'semanal' ? `toda ${diaSemana(form.vencimento)}` : repetir === 'quinzenal' ? `a cada 15 dias (${diaSemana(form.vencimento)})` : repetir === 'mensal' ? `todo dia ${form.vencimento ? form.vencimento.slice(8, 10) : ''}` : '';
  const cats = tipo === 'pagar' ? (categorias?.pagar || []) : (categorias?.receber || []);
  const subs = (cats.find(c => c.nome === form.categoria)?.subs) || [];
  // Formas parceladas mostram o campo de quantidade de parcelas (só em novo lançamento)
  const ehParcelada = /parcelad/i.test(form.forma_pagamento) && !editar && !repetir;

  // Vínculo dinâmico: A receber → cliente · A pagar → fornecedor
  const ehPagar = tipo === 'pagar';
  const [clientes, setClientes] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [buscaEnt, setBuscaEnt] = useState(inicial.fornecedor_nome || inicial.cliente_nome || '');
  const [abertoEnt, setAbertoEnt] = useState(false);
  useEffect(() => {
    apiGet('clientes').then(d => Array.isArray(d) && setClientes(d)).catch(() => {});
    apiGet('fornecedores').then(d => Array.isArray(d) && setFornecedores(d)).catch(() => {});
  }, []);
  const nomeEnt = (c) => c.nome || c.razao_social || c.responsavel || c.fantasia || '(sem nome)';
  const listaEnt = ehPagar ? fornecedores : clientes;
  const vinculadoNome = ehPagar ? form.fornecedor_nome : form.cliente_nome;
  const vinculadoId = ehPagar ? form.fornecedor_id : form.cliente_id;
  const matches = buscaEnt.trim().length >= 1
    ? listaEnt.filter(c => nomeEnt(c).toLowerCase().includes(buscaEnt.trim().toLowerCase())).slice(0, 8)
    : [];
  const escolherEnt = (c) => {
    if (ehPagar) setForm(f => ({ ...f, fornecedor_id: c._id, fornecedor_nome: nomeEnt(c), cliente_id: '', cliente_nome: '' }));
    else setForm(f => ({ ...f, cliente_id: c._id, cliente_nome: nomeEnt(c), fornecedor_id: '', fornecedor_nome: '' }));
    setBuscaEnt(nomeEnt(c)); setAbertoEnt(false);
  };
  const limparEnt = () => { setForm(f => ({ ...f, cliente_id: '', cliente_nome: '', fornecedor_id: '', fornecedor_nome: '' })); setBuscaEnt(''); };
  // Ao trocar o tipo, limpa o vínculo (cliente não vale pra pagar e vice-versa)
  const trocarTipo = (t) => { setTipo(t); if (t !== tipo) { setForm(f => ({ ...f, cliente_id: '', cliente_nome: '', fornecedor_id: '', fornecedor_nome: '', categoria: '', subcategoria: '' })); setBuscaEnt(''); } };

  const salvar = async () => {
    if (!form.descricao.trim()) return alert('Informe a descrição.');
    if (!form.valor) return alert('Informe o valor.');
    if (!editar && repetir && !form.vencimento) return alert('Informe a data do 1º lançamento para repetir.');
    setSalvando(true);
    if (!editar && repetir && Number(numRepeticoes) > 1) {
      // Lançamento recorrente: cria N avulsos repetidos (semanal/quinzenal/mensal)
      await apiSend('financeiro/recorrente', 'POST', {
        tipo, descricao: form.descricao, valor: form.valor, num_repeticoes: numRepeticoes,
        frequencia: repetir, data_primeira: form.vencimento,
        categoria: form.categoria, subcategoria: form.subcategoria, forma_pagamento: form.forma_pagamento,
        cliente_id: form.cliente_id, cliente_nome: form.cliente_nome,
        fornecedor_id: form.fornecedor_id, fornecedor_nome: form.fornecedor_nome,
      });
    } else if (!editar && ehParcelada && Number(numParcelas) > 1) {
      // Lançamento parcelado: cria N parcelas (mesma fonte de verdade do resto)
      await apiSend('financeiro/parcelado', 'POST', {
        tipo, descricao: form.descricao, valor_total: form.valor, num_parcelas: numParcelas,
        quantidade,
        data_primeira: form.vencimento, categoria: form.categoria, subcategoria: form.subcategoria,
        forma_pagamento: form.forma_pagamento,
        cliente_id: form.cliente_id, cliente_nome: form.cliente_nome,
        fornecedor_id: form.fornecedor_id, fornecedor_nome: form.fornecedor_nome,
      });
    } else {
      const body = { tipo, ...form, quantidade };
      if (editar) await apiSend(`financeiro/${inicial.id}`, 'PUT', body);
      else await apiSend('financeiro', 'POST', body);
    }
    setSalvando(false);
    onSalvo();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, padding: 24, width: 440, maxWidth: '92%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        <h2 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: '0 0 16px' }}>{editar ? 'Editar lançamento' : 'Novo lançamento'}</h2>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          {['receber', 'pagar'].map(t => (
            <button key={t} onClick={() => trocarTipo(t)} disabled={editar} style={{
              flex: 1, padding: '8px', fontSize: 13, fontWeight: 600, borderRadius: 8, cursor: editar ? 'default' : 'pointer',
              border: '1px solid ' + (tipo === t ? '#0a1628' : '#d1d5db'),
              background: tipo === t ? (t === 'receber' ? '#16a34a' : '#dc2626') : '#fff',
              color: tipo === t ? '#fff' : '#374151', opacity: editar && tipo !== t ? 0.4 : 1,
            }}>{t === 'receber' ? 'A receber' : 'A pagar'}</button>
          ))}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <input value={form.descricao} onChange={set('descricao')} placeholder="Descrição (ex: Taxa INPI marca X)" style={{ ...inp, width: '100%', boxSizing: 'border-box' }} />
          <div style={{ display: 'flex', gap: 10 }}>
            {tipo === 'receber' && !editar && (
              <select value={quantidade} onChange={e => setQuantidade(e.target.value)} title="Quantidade de itens da venda (ex.: 2 registros de marca)" style={{ ...inp, width: 86 }}>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => <option key={n} value={n}>{n}× qtd</option>)}
              </select>
            )}
            <input value={form.valor} onChange={e => setForm({ ...form, valor: mascaraMoeda(e.target.value) })} inputMode="numeric" placeholder={tipo === 'receber' ? 'Valor TOTAL (R$)' : 'Valor (R$)'} style={{ ...inp, flex: 1 }} />
            <input type="date" value={form.vencimento} onChange={set('vencimento')} style={{ ...inp, flex: 1 }} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <select value={form.categoria} onChange={e => setForm({ ...form, categoria: e.target.value, subcategoria: '' })} style={{ ...inp, flex: 1 }}>
              <option value="">Categoria</option>{cats.map(c => <option key={c.nome} value={c.nome}>{c.nome}</option>)}
            </select>
            <select value={form.forma_pagamento} onChange={set('forma_pagamento')} style={{ ...inp, flex: 1 }}>
              <option value="">Forma</option>{(formas || []).map(x => <option key={x} value={x}>{x}</option>)}
            </select>
          </div>
          {subs.length > 0 && (
            <select value={form.subcategoria} onChange={set('subcategoria')} style={{ ...inp, width: '100%', boxSizing: 'border-box' }}>
              <option value="">Subcategoria (opcional)</option>{subs.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          )}
          {ehParcelada && (
            <div style={{ background: '#f5f7fa', border: '1px solid #e2e8f0', borderRadius: 6, padding: '8px 10px' }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: '#374151', whiteSpace: 'nowrap' }}>Nº de parcelas:</span>
                <select value={numParcelas} onChange={e => setNumParcelas(e.target.value)} style={{ ...inp, width: 90 }}>
                  {Array.from({ length: 24 }, (_, k) => k + 1).map(n => <option key={n} value={n}>{n}x</option>)}
                </select>
                {Number(numParcelas) > 1 && form.valor && (
                  <span style={{ fontSize: 12, color: '#6b7280' }}>{numParcelas}x de {moeda((parseFloat(String(form.valor).replace(/\./g, '').replace(',', '.')) || 0) / Number(numParcelas))} · a data acima é o 1º vencimento</span>
                )}
              </div>
            </div>
          )}
          {!editar && (
            <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 6, padding: '8px 10px' }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: '#374151', whiteSpace: 'nowrap' }}>🔁 Repetir:</span>
                <select value={repetir} onChange={e => setRepetir(e.target.value)} style={{ ...inp, width: 160 }}>
                  <option value="">Não repetir</option>
                  <option value="semanal">Toda semana</option>
                  <option value="quinzenal">A cada 15 dias</option>
                  <option value="mensal">Todo mês</option>
                </select>
                {repetir && (
                  <>
                    <span style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>Nº de vezes:</span>
                    <select value={numRepeticoes} onChange={e => setNumRepeticoes(e.target.value)} style={{ ...inp, width: 80 }}>
                      {Array.from({ length: 51 }, (_, k) => k + 2).map(n => <option key={n} value={n}>{n}x</option>)}
                    </select>
                  </>
                )}
              </div>
              {repetir && (
                <div style={{ fontSize: 11, color: '#0369a1', marginTop: 6 }}>
                  {form.vencimento
                    ? <>{numRepeticoes}x de {moeda(valorNum)} · {freqTxt} · total {moeda(valorNum * Number(numRepeticoes))}</>
                    : 'Escolha a data acima — ela é o 1º lançamento e define o dia da semana.'}
                </div>
              )}
            </div>
          )}
          <div style={{ position: 'relative' }}>
            <div style={{ display: 'flex', gap: 6 }}>
              <input
                value={buscaEnt}
                onChange={e => { setBuscaEnt(e.target.value); setAbertoEnt(true); if (vinculadoId) setForm(f => ({ ...f, cliente_id: '', cliente_nome: '', fornecedor_id: '', fornecedor_nome: '' })); }}
                onFocus={() => setAbertoEnt(true)}
                placeholder={ehPagar ? 'Fornecedor (buscar por nome) — opcional' : 'Cliente (buscar por nome) — opcional'}
                style={{ ...inp, flex: 1, boxSizing: 'border-box' }} />
              {vinculadoId && <button onClick={limparEnt} title="Limpar" style={{ ...inp, cursor: 'pointer', color: '#6b7280' }}>✕</button>}
            </div>
            {vinculadoId && <div style={{ fontSize: 11, color: '#16a34a', marginTop: 2 }}>✓ vinculado a {vinculadoNome} <span style={{ color: '#9ca3af' }}>({ehPagar ? 'fornecedor' : 'cliente'})</span></div>}
            {abertoEnt && matches.length > 0 && !vinculadoId && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, marginTop: 2, maxHeight: 200, overflowY: 'auto', zIndex: 10, boxShadow: '0 4px 12px rgba(0,0,0,0.12)' }}>
                {matches.map(c => (
                  <div key={c._id} onClick={() => escolherEnt(c)} style={{ padding: '5px 10px', fontSize: 12, cursor: 'pointer', borderBottom: '1px solid #f3f4f6' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                    {nomeEnt(c)}
                  </div>
                ))}
              </div>
            )}
            {ehPagar && fornecedores.length === 0 && !vinculadoId && <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>Nenhum fornecedor cadastrado ainda.</div>}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
          <button onClick={onFechar} style={{ ...inp, cursor: 'pointer', color: '#374151' }}>Cancelar</button>
          <button onClick={salvar} disabled={salvando} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 20px', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>
    </div>
  );
}


// ── 💰 Baixa em lote (12/08): marca várias parcelas ABERTAS do filtro atual e
// quita todas de uma vez com a mesma data/forma. IDs de venda antiga (venda:*)
// ficam de fora — a baixa deles é individual.
function ModalBaixaLote({ itens, formas, onFechar, onSalvo }) {
  const abertos = (itens || []).filter(it => it.status === 'aberto' && !String(it.id).startsWith('venda:'));
  const [sel, setSel] = useState(new Set());
  const [data, setData] = useState(hojeISO());
  const [forma, setForma] = useState('');
  const [salvando, setSalvando] = useState(false);
  const alternar = (id) => setSel(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const total = abertos.filter(it => sel.has(it.id)).reduce((s, it) => s + (Number(it.valor) || 0), 0);

  async function confirmar() {
    if (!sel.size) return alert('Marque pelo menos uma parcela.');
    if (!window.confirm(`Dar baixa em ${sel.size} parcela(s), total ${moeda(total)}, na data ${fmtData(data)}?`)) return;
    setSalvando(true);
    const r = await apiSend('financeiro/baixa-lote', 'POST', { ids: [...sel], data_pagamento: data, forma });
    setSalvando(false);
    if (r?.erro) return alert(r.erro);
    alert(`${r.baixadas} baixada(s)${r.puladas ? ` · ${r.puladas} pulada(s)` : ''}.`);
    onSalvo();
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 620, maxWidth: '96vw', maxHeight: '88vh', display: 'flex', flexDirection: 'column', padding: 18 }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: '#0a1628', marginBottom: 4 }}>💰 Baixa em lote</div>
        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>{abertos.length} parcela(s) em aberto no filtro atual — marque as que foram pagas/recebidas.</div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div><label style={{ fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block' }}>Data</label>
            <input type="date" value={data} onChange={e => setData(e.target.value)} style={inp} /></div>
          <div><label style={{ fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block' }}>Forma</label>
            <select value={forma} onChange={e => setForma(e.target.value)} style={inp}><option value="">—</option>{(formas || []).map(x => <option key={x} value={x}>{x}</option>)}</select></div>
          <button onClick={() => setSel(new Set(abertos.map(it => it.id)))} style={{ ...inp, cursor: 'pointer' }}>marcar todas</button>
          <button onClick={() => setSel(new Set())} style={{ ...inp, cursor: 'pointer' }}>desmarcar</button>
        </div>
        <div style={{ overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 6, flex: 1 }}>
          {abertos.map(it => (
            <label key={it.id} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '5px 10px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', background: sel.has(it.id) ? '#f0fdf4' : '#fff', fontSize: 12.5 }}>
              <input type="checkbox" checked={sel.has(it.id)} onChange={() => alternar(it.id)} />
              <span>{it.tipo === 'receber' ? '📥' : '📤'}</span>
              <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.descricao} {it.cliente_nome || it.fornecedor_nome ? `· ${it.cliente_nome || it.fornecedor_nome}` : ''}</span>
              <span style={{ color: '#6b7280' }}>{fmtData(it.vencimento)}</span>
              <b>{moeda(it.valor)}</b>
            </label>
          ))}
          {!abertos.length && <div style={{ padding: 14, fontSize: 13, color: '#6b7280' }}>Nenhuma parcela aberta no filtro atual.</div>}
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
          <span style={{ fontSize: 13, color: '#0a1628' }}>{sel.size} marcada(s) · total <b>{moeda(total)}</b></span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={onFechar} style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 16px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
            <button onClick={confirmar} disabled={salvando || !sel.size}
              style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: salvando || !sel.size ? .5 : 1 }}>
              {salvando ? 'Baixando…' : '💰 Dar baixa nas marcadas'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
